// extracted by mini-css-extract-plugin
export default {"carousel":"image-cards_carousel__WWc7I","card-container":"image-cards_card-container__ssmhw","card":"image-cards_card__EZbXJ"};